/* eslint arrow-body-style: 0 */
import ConversationView from './Index.vue';
import { frontendURL } from '../../../../helper/URLHelper';
import { dispatchAccountPreference } from '../../../../helper/userPreferencesHelper';
import store from '../../../../store';

async function saveLastBoard(accountId, boardId) {
  return dispatchAccountPreference(
    store,
    accountId,
    'last_board',
    String(boardId)
  );
}

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/pipelines'),
      beforeEnter: async (to, from, next) => {
        const { accountId } = to.params;
        const currentUser = store.getters.getCurrentUser;

        const userPrefs = currentUser?.ui_settings?.user_preferences_by_account;
        let boardId = userPrefs?.[accountId]?.last_board;

        // Fallback: Try localStorage for migration
        if (!boardId) {
          boardId = localStorage.getItem(`selectedboard_${accountId}`);
          if (boardId) {
            const saved = await saveLastBoard(accountId, boardId);
            if (saved) {
              localStorage.removeItem(`selectedboard_${accountId}`);
            }
          }
        }

        // If still no boardId, get first board
        if (!boardId) {
          await store.dispatch('pipelines/getBoards');
          const boards = store.getters['pipelines/getAllBoards'];
          boardId = boards.length > 0 ? boards[0].id : '1';

          await saveLastBoard(accountId, boardId);
        }

        next(frontendURL(`accounts/${accountId}/pipelines/boards/${boardId}`));
      },
      name: 'pipeline',
      roles: ['administrator', 'agent'],
      component: ConversationView,
      props: () => {
        return { inboxId: 0 };
      },
    },
    {
      path: frontendURL('accounts/:accountId/pipelines/boards/:board_id'),
      beforeEnter: async (to, from, next) => {
        const { accountId, board_id } = to.params;
        await store.dispatch('pipelines/getBoards');
        const boards = store.getters['pipelines/getAllBoards'];
        const found = boards.some(board => String(board.id) === String(board_id));

        if (found) {
          await saveLastBoard(accountId, board_id);
          next();
        } else {
          if (boards.length > 0) {
            alert('Board not found and will redirect to Default Board');
            const boardId = boards[boards.length - 1].id;

            await saveLastBoard(accountId, boardId);

            next(frontendURL(`accounts/${accountId}/pipelines/boards/${boardId}`));
          } else {
            alert('No board found, create a board first');
            next(frontendURL(`accounts/${accountId}/settings/board`));
          }
        }
      },
      name: 'pipeline_boards',
      roles: ['administrator', 'agent'],
      component: ConversationView,
      props: (route) => {
        return { board_id: route.params.board_id };
      },
    },
    {
      path: frontendURL(
        'accounts/:accountId/pipelines/boards/:board_id/custom_view/:id'
      ),
      name: 'pipeline_custom_view',
      roles: ['administrator', 'agent'],
      component: ConversationView,
      beforeEnter: async (to, from, next) => {
        const { accountId, board_id } = to.params;

        const currentUser = store.getters.getCurrentUser;
        const userPrefs = currentUser?.ui_settings?.user_preferences_by_account;
        let boardId = board_id || userPrefs?.[accountId]?.last_board;

        if (!boardId) {
          await store.dispatch('pipelines/getBoards');
          const boards = store.getters['pipelines/getAllBoards'];
          boardId = boards.length > 0 ? boards[0].id : '1';
        }

        await saveLastBoard(accountId, boardId);

        next();
      },
      props: route => {
        return {
          board_id: route.params.board_id,
          boardFilterId: route.params.id,
        };
      },
    },
    {
      path: frontendURL('accounts/:accountId/pipelines/custom_view/:id'),
      name: 'pipeline_custom_view_legacy',
      roles: ['administrator', 'agent'],
      beforeEnter: async (to, from, next) => {
        const { accountId, id } = to.params;

        const currentUser = store.getters.getCurrentUser;
        const userPrefs = currentUser?.ui_settings?.user_preferences_by_account;
        const boardId = to.query.board_id || userPrefs?.[accountId]?.last_board || '1';

        next(
          frontendURL(
            `accounts/${accountId}/pipelines/boards/${boardId}/custom_view/${id}`
          )
        );
      },
    },
  ],
};
